'use strict';
var path = require('path');

module.exports = function (str) {
	return path.resolve(str) === path.resolve(process.cwd());
};



//////////////////
// WEBPACK FOOTER
// ./~/is-path-cwd/index.js
// module id = 3098
// module chunks = 0